<template>
  <v-container fluid>
    <BaseTableFiltered
        ref="baseTableRef"
        :title="$t('BatchRunTask')"
        :subtractHeight="subtractHeight"
        :height="height"
        dto-model="BatchRunTaskListQueryDTO"
        dto-save-list-model="BatchRunTaskSaveListCommandDTO"
        store-name="PBatchRunTaskTable"
        new-item-component="PBatchRunTaskItem"
        new-item-pass="/PBatchRun/BatchRunTask/PBatchRunTaskItem"
        :lang-dictionary="function(text) {return $t(text)}"
        fixed-header
        row-statuses="row_statuses"
        show-selected
        :single-select="singleSelect"
        :action-selected="actionSelected"
        :init-search-term="initSearchTerm"
        @choice="$emit('choice', $event)"
        @changeSearchTerm="$emit('changeSearchTerm', $event)"
        @item-selected="$emit('item-selected', $event)"
        :metadata="metadata"
        @click:row="$emit('click:row', $event)"
    >
      <!--      <template v-slot:item.name="{ item }">-->
      <!--        <router-link :to="{name:'PBatchRunTaskItem', params: { itemUid: item.uid}}">-->
      <!--          <span class="d-flex justify-start">{{ item.name }}</span>-->
      <!--        </router-link>-->
      <!--      </template>-->
      <template v-slot:item.notion_id="{ item }">
        <BaseNotionLink :value="item.notion_id" small outlined></BaseNotionLink>
      </template>
      <template v-slot:item.typ="{ item }">
        <BatchRunTaskName :value="item.typ" small outlined></BatchRunTaskName>
      </template>
      <template v-slot:item.batch_run__customer_order__title="{ item }">
        <router-link :to="{name:'PCustomerOrderSoloItem', params: { itemUid: item.batch_run__customer_order__uid}}">
          <span class="d-flex justify-start">{{ item.batch_run__customer_order__title }}</span>
        </router-link>
      </template>
      <template v-slot:item.batch_run__customer_order__notion_id="{ item }">
        <BaseNotionLink :value="item.batch_run__customer_order__notion_id" small outlined></BaseNotionLink>
      </template>
      <template v-slot:item.batch_run__title="{ item }">
        <router-link :to="{name:'PBatchRunItem', params: { itemUid: item.batch_run__uid}}">
          <span class="d-flex justify-start">{{ item.batch_run__title }}</span>
        </router-link>
      </template>
      <template v-slot:item.batch_run__notion_id="{ item }">
        <BaseNotionLink :value="item.batch_run__notion_id" small outlined></BaseNotionLink>
      </template>
      <template v-slot:item.ma="{ item }">
        <v-chip
            v-for="(user, index) of item.ma"
            :key="index"
            small
            outlined
            class="mb-1"
        >
          {{ user.human_user__user }}
        </v-chip>
        {{ '' }}
      </template>
    </BaseTableFiltered>
    <v-dialog max-width="900" v-model="informationDialog">
      <v-card max-height="600" class="overflow-y-auto">
        {{ information }}
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import BaseImageCard from "@/components/Base/BaseImageCard";
import commonFunction from "@/commonFunction/commonFunction";
import BaseTableFiltered from "@/components/Base/BaseTableFieltered";
import BaseFilterGroupTable from "@/components/Base/BaseFilterGroupTable";
import BaseNotionLink from "@/components/Base/BaseNotionLink";
import BatchRunTaskName from "@/components/PBatchRun/BatchRunTask/BatchRunTaskName";
import BaseSelectFromTable from "@/components/Base/BaseSelectFromTable";

export default {
  name: 'PBatchRunTaskTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false},
    singleSelect: {type: [Boolean], default: false},
    actionSelected: {default: false},
    initSearchTerm: {default: null},
    metadata: {default: null},
  },

  components: {
    BaseImageCard,
    BaseTableFiltered,
    BaseFilterGroupTable,
    BaseNotionLink,
    BatchRunTaskName,
    BaseSelectFromTable,
  },

  computed: {
    ...commonFunction.mapStoreFields([]),
  },

  methods: {
    exportAction(instance) {
      let selected_uid_list = []
      instance.selectedItemList.forEach(row => selected_uid_list.push(row.uid))
      let dto_search = {
        current_uid: null,
        selected_uid_list: selected_uid_list,
      }
      instance.fetchAction({dto: dto_search, dto_action_model: this.dto_export_model})
    },

  },

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {
      informationDialog: false,
      information: null,
    }
  }
}
</script>

<style>
.row_even {
}
</style>


<i18n src="@/components/PBatchRun/locales.json">
</i18n>
